module.exports = __webpack_public_path__ + "55c8d701fac144d37047eae009569367.pdf";